module.exports = __webpack_public_path__ + "static/img/ordericon2.f1bcd41e.png";